import Clasicas from 'imgs/new-products/CLASICAS.png';
import Gourmet from 'imgs/new-products/GOURMET.png'
import Junior from 'imgs/new-products/JUNIOR.png'
import LomitoNuggets from 'imgs/new-products/LOMITO-NUGGETs.png'
import Mega from 'imgs/new-products/MEGA.png'
import Pollo from 'imgs/new-products/POLLO.png'
import SaladCheddar from 'imgs/new-products/SALAD-CHEDDAR.png'
import Smash from 'imgs/new-products/SMASH.png'

const CarouselImagesMobile = [
    {
        id: 1,
        url: Clasicas,
    },
    {
        id: 2,
        url: Gourmet,
    }, {
        id: 3,
        url: Junior,
    }, {
        id: 4,
        url: LomitoNuggets,
    }, {
        id: 5,
        url: Mega,
    }, {
        id: 6,
        url: Pollo,
    }, {
        id: 7,
        url: SaladCheddar,
    }, {
        id: 8,
        url: Smash,
    }
];

export default CarouselImagesMobile;